import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import React from "react";
import Spinner from "../components/Spinner/Spinner";
import { useUserState } from "../context/UserContext";
import AccessControl from "../views/AccessControl";
import { MyFallbackComponent } from "../views/FallBackComponent";
import NoPermission from "../views/NoPermission";

export const AuthenticationGuard = ({
  component,
  page,
  friendlyName,
  strict,
}) => {
  const { error } = useAuth0();

  //eslint-disable-next-line
  const [loading, setLoading] = React.useState(false);
  const userPermission = useUserState();

  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => <Spinner />,
  });
  if (error) {
    console.log("error", error);
    return <MyFallbackComponent error={error?.message} />;
  }
  if (loading || !userPermission) {
    return <Spinner />;
  }

  return (
    <AccessControl
      userPermissions={userPermission}
      unallowedPermissions={{
        page: page,
        // allow: false,
        action: "view",
        strict: strict ? strict : false,
      }}
      renderNoAccess={() => (
        <NoPermission dbName={friendlyName ? friendlyName : page} />
      )}
    >
      <Component />
    </AccessControl>
  );
};
